import axios from 'axios';
import Qs from 'qs'
let base = 'http://web.biaima.com.cn:8889';
let business = 'http://web.biaima.com.cn:8888';
let model ='http://web.biaima.com.cn:8890';

//let base = 'http://127.0.0.1:8889'//用户权限系统
//let business ='http://127.0.0.1:8888'//业务系统
// let model ='http://127.0.0.1:8890'//模型系统

//BIM模型=============================================================================
//模型对象 增 删 改 查 及 详情
export const searchModel = (params,header) => { return axios.post(`${model}/model/search`,params,header).then(res => res.data); };
export const createModel = (params,header) => { return axios.post(`${model}/model/create`,params,header).then(res => res.data); };
export const updateModel = (params,header) => { return axios.post(`${model}/model/update`,params,header).then(res => res.data); };
export const deleteModel = (params,header) => { return axios.post(`${model}/model/delete`,params,header).then(res => res.data); };
export const detailModel = (params,header) => { return axios.post(`${model}/model/detail`,params,header).then(res => res.data); };
export const excuteModel = (params,header) => { return axios.post(`${model}/model/excute`,params,header).then(res => res.data); };
export const treeModel = (params,header) => { return axios.post(`${model}/model/modeltree`,params,header).then(res => res.data); };
export const childrenModel = (params,header) => { return axios.post(`${model}/model/modeltreechildren`,params,header).then(res => res.data); };
export const setRoam = (params,header) => { return axios.post(`${model}/model/setroam`,params,header).then(res => res.data); };
export const roamList = (params,header) => { return axios.post(`${model}/model/roamlist`,params,header).then(res => res.data); };
export const delRoam = (params,header) => { return axios.post(`${model}/model/delroam`,params,header).then(res => res.data); };
export const towerConfig = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/Project/ScreenUpdate`,params,header).then(res => res.data); };
export const towerConfigByProId = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/Project/ScreenDetail`,params,header).then(res => res.data); };

//登录接口 执行登录
export const doLogin = (params) => { return axios.post(`${base}/user/dologin`,params).then(res => res.data); };
//系统管理=============================================================
//查询公司数据
export const comSearch = (params,header) => { return axios.post(`${base}/sysmanager/com/search`,params,header).then(res => res.data); };
//添加公司
export const comCreate = (params,header) => { return axios.post(`${base}/sysmanager/com/create`,params,header).then(res => res.data); };
//修改公司
export const comUpdate = (params,header) => { return axios.post(`${base}/sysmanager/com/update`,params,header).then(res => res.data); };
//删除公司
export const comDelete = (params,header) => { return axios.post(`${base}/sysmanager/com/delete`,params,header).then(res => res.data); };
//公司详情
export const comDetail = (params,header) => { return axios.post(`${base}/sysmanager/com/detail`,params,header).then(res => res.data); };
//下级公司
export const comChildren = (params,header) => { return axios.post(`${base}/sysmanager/com/children`,params,header).then(res => res.data); };


//查询项目数据
export const proSearch = (params,header) => { return axios.post(`${base}/sysmanager/project/search`,params,header).then(res => res.data); };
//添加项目
export const proCreate = (params,header) => { return axios.post(`${base}/sysmanager/project/create`,params,header).then(res => res.data); };
//修改项目
export const proUpdate = (params,header) => { return axios.post(`${base}/sysmanager/project/update`,params,header).then(res => res.data); };
//删除项目
export const proDelete = (params,header) => { return axios.post(`${base}/sysmanager/project/delete`,params,header).then(res => res.data); };
//项目详情
export const proDetail = (params,header) => { return axios.post(`${base}/sysmanager/project/detail`,params,header).then(res => res.data); };



//查询岗位数据
export const roleSearch = (params,header) => { return axios.post(`${base}/sysmanager/role/search`,params,header).then(res => res.data); };
//添加岗位
export const roleCreate = (params,header) => { return axios.post(`${base}/sysmanager/role/create`,params,header).then(res => res.data); };
//修改岗位
export const roleUpdate = (params,header) => { return axios.post(`${base}/sysmanager/role/update`,params,header).then(res => res.data); };
//删除岗位
export const roleDelete = (params,header) => { return axios.post(`${base}/sysmanager/role/delete`,params,header).then(res => res.data); };
//岗位详情
export const roleDetail = (params,header) => { return axios.post(`${base}/sysmanager/role/detail`,params,header).then(res => res.data); };
///下级岗位
export const roleChildren = (params,header) => { return axios.post(`${base}/sysmanager/role/children`,params,header).then(res => res.data); };
//上级岗位
export const roleParent = (params,header) => { return axios.post(`${base}/sysmanager/role/parent`,params,header).then(res => res.data); };
//是否父级岗位
export const roleIsParent = (params,header) => { return axios.post(`${base}/sysmanager/role/isparent`,params,header).then(res => res.data); };
//功能列表
export const funs = (params,header) => { return axios.post(`${base}/sysmanager/fun/funs`,params,header).then(res => res.data); };
//功能列表
export const roleFuns = (params,header) => { return axios.post(`${base}/sysmanager/fun/rolefuns`,params,header).then(res => res.data); };

//用户接口====================================================================
//条件分页用户数据
export const userSearch = (params,header) => { return axios.post(`${base}/user/search`,params,header).then(res => res.data); };
//添加用户
export const userCreate = (params,header) => { return axios.post(`${base}/user/create`,params,header).then(res => res.data); };
//修改用户
export const userUpdate = (params,header) => { return axios.post(`${base}/user/update`,params,header).then(res => res.data); };
//删除用户
export const userDel = (params,header) => { return axios.post(`${base}/user/delete`,params,header).then(res => res.data); };
//用户详情
export const userDetail = (params,header) => { return axios.post(`${base}/user/detail`,params,header).then(res => res.data); };

//验证姓名唯一性
export const nameSingle = (params,header) => { return axios.post(`${base}/user/namesingle`,params,header).then(res => res.data); };

//验证身份证唯一性
export const codeSingle = (params,header) => { return axios.post(`${base}/user/codesingle`,params,header).then(res => res.data); };

//验证手机号唯一性
export const telSingle = (params,header) => { return axios.post(`${base}/user/telsingle`,params,header).then(res => res.data); };

//修改密码
export const updatePwd = (params,header) => { return axios.post(`${base}/user/updatepwd`,params,header).then(res => res.data); };

//用户数据导出
export const userExport = (params,header) => { return axios.post(`${base}/user/export`,params,header).then(res => res); };
//根据身份证获取用户数据
export const codeData = (params,header) => { return axios.post(`${base}/user/codedata`,params,header).then(res => res.data); };


//通用字典数据相关接口==================================================
//获取所有工种
export const dataList = (params,header) => { return axios.post(`${business}/data/list`,params,header).then(res => res.data); };
//获取指定岗位标记的用户集合（岗位标记包装）
export const workers = (params,header) => { return axios.post(`${business}/data/roletag/user`,params,header).then(res => res.data); };
//获取指定岗位标记的岗位集合
export const tagRoles = (params,header) => { return axios.post(`${business}/data/roletag/role`,params,header).then(res => res.data); };
//获取指定岗位的用户集合（岗位编号包装）
export const roleUser = (params,header) => { return axios.post(`${business}/data/role/user`,params,header).then(res => res.data); };




//整改接口====================================================================
//查询整改数据
export const rectifySearch = (params,header) => { return axios.post(`${business}/rectify/search`,params,header).then(res => res.data); };
//添加整改数据
export const rectifyCreate = (params,header) => { return axios.post(`${business}/rectify/create`,params,header).then(res => res.data); };
//获取某一详情
export const rectifyDetail = (params,header) => { return axios.post(`${business}/rectify/detail`,params,header).then(res => res.data); };
//修改整改数据
export const rectifyUpdate = (params,header) => { return axios.post(`${business}/rectify/update`,params,header).then(res => res.data); };
//删除整改数据
export const rectifyDel = (params,header) => { return axios.post(`${business}/rectify/delete`,params,header).then(res => res.data); };
//修改整改状态
export const rectifyStatus = (params,header) => { return axios.post(`${business}/rectify/status`,params,header).then(res => res.data); };
//回复整改单
export const rectifyConfirm = (params,header) => { return axios.post(`${business}/rectify/confirm`,params,header).then(res => res.data); };
//获取某一整改单回复
export const rectifyConfirmMes = (params,header) => { return axios.post(`${business}/rectify/confirmmessage`,params,header).then(res => res.data); };
//导出整改单DOC
export const rectifydoc = (params,header) => { return axios.post(`${business}/document/rectifydoc`,params,header).then(res => res.data); };
//交底接口====================================================================
//查询交底数据
export const discloseSearch = (params,header) => { return axios.post(`${business}/disclose/search`,params,header).then(res => res.data); };
//添加交底数据
export const discloseCreate = (params,header) => { return axios.post(`${business}/disclose/create`,params,header).then(res => res.data); };
//获取某一详情
export const discloseDetail = (params,header) => { return axios.post(`${business}/disclose/detail`,params,header).then(res => res.data); };
//修改交底数据
export const discloseUpdate = (params,header) => { return axios.post(`${business}/disclose/update`,params,header).then(res => res.data); };
//删除交底数据
export const discloseDel = (params,header) => { return axios.post(`${business}/disclose/delete`,params,header).then(res => res.data); };
//导出交底单DOC
export const disclosedoc = (params,header) => { return axios.post(`${business}/document/disclosedoc`,params,header).then(res => res.data); };
//修改对应交底单的用户数据
export const updateByuseranddis = (params,header) => { return axios.post(`${business}/disclose/updatebyuseranddis`,params,header).then(res => res.data); };
//获取某一交底单的交底人数据
export const usersBydisid = (params,header) => { return axios.post(`${business}/disclose/usersbydisid`,params,header).then(res => res.data); };

//附件资料======================================================================
//添加附件资料
export const dataCreate = (params,header) => { return axios.post(`${business}/enc/create`,params,header).then(res => res.data); };
//修改附件资料
export const dataUpdate = (params,header) => { return axios.post(`${business}/enc/update`,params,header).then(res => res.data); };
//删除附件资料
export const dataDel = (params,header) => { return axios.post(`${business}/enc/delete`,params,header).then(res => res.data); };
//查询附件资料
export const dataSearch = (params,header) => { return axios.post(`${business}/enc/search`,params,header).then(res => res.data); };
//获取某一详情
export const dataDetail = (params,header) => { return axios.post(`${business}/enc/detail`,params,header).then(res => res.data); };
//设备==========================================================================
//添加设备
export const deviceCreate = (params,header) => { return axios.post(`${business}/device/create`,params,header).then(res => res.data); };
//修改设备
export const deviceUpdate = (params,header) => { return axios.post(`${business}/device/update`,params,header).then(res => res.data); };
//删除设备
export const deviceDel = (params,header) => { return axios.post(`${business}/device/delete`,params,header).then(res => res.data); };
//查询设备
export const deviceSearch = (params,header) => { return axios.post(`${business}/device/search`,params,header).then(res => res.data); };
//获取某一详情
export const deviceDetail = (params,header) => { return axios.post(`${business}/device/detail`,params,header).then(res => res.data); };

//工程动态======================================================================
//添加动态
export const mesCreate = (params,header) => { return axios.post(`${business}/mes/create`,params,header).then(res => res.data); };
//修改动态
export const mesUpdate = (params,header) => { return axios.post(`${business}/mes/update`,params,header).then(res => res.data); };
//删除动态
export const mesDel = (params,header) => { return axios.post(`${business}/mes/delete`,params,header).then(res => res.data); };
//查询动态
export const mesSearch = (params,header) => { return axios.post(`${business}/mes/search`,params,header).then(res => res.data); };
//获取某一详情
export const mesDetail = (params,header) => { return axios.post(`${business}/mes/detail`,params,header).then(res => res.data); };

//在线考试======================================================================
//添加
export const examCreate = (params,header) => { return axios.post(`${business}/exam/create`,params,header).then(res => res.data); };
//修改
export const examUpdate = (params,header) => { return axios.post(`${business}/exam/update`,params,header).then(res => res.data); };
//删除
export const examDel = (params,header) => { return axios.post(`${business}/exam/delete`,params,header).then(res => res.data); };
//查询
export const examSearch = (params,header) => { return axios.post(`${business}/exam/search`,params,header).then(res => res.data); };
//获取某一详情
export const examDetail = (params,header) => { return axios.post(`${business}/exam/detail`,params,header).then(res => res.data); };
//获取最大题号
export const examNO = (params,header) => { return axios.post(`${business}/exam/maxno`,params,header).then(res => res.data); };
//修改状态
export const examStatus = (params,header) => { return axios.post(`${business}/exam/status`,params,header).then(res => res.data); };
//获得对应题号的题目
export const examQues = (params,header) => { return axios.post(`${business}/exam/ques`,params,header).then(res => res.data); };
//试卷作答
export const doExam = (params,header) => { return axios.post(`${business}/exam/doexam`,params,header).then(res => res.data); };
//试卷作答详情
export const doExamMes = (params,header) => { return axios.post(`${business}/exam/doexammes`,params,header).then(res => res.data); };
//随机试卷
export const randomExam = (params,header) => { return axios.post(`${business}/exam/randomdata`,params,header).then(res => res.data); };
//用户作答情况
export const userExamMes = (params,header) => { return axios.post(`${business}/exam/userexammes`,params,header).then(res => res.data); };



//总览==========================================================================
//环境监测
export const environment = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/IndexV2/Environment`,params,header).then(res => res); };
//劳动力情况
export const members = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/IndexV2/Members`,params,header).then(res => res); };
//安全数据
export const safe = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/IndexV2/Safe`,params,header).then(res => res); };
//安全管理
export const safeMonitor = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/SafeManagerV2/SafeMonitor`,params,header).then(res => res); };
//质量管理

export const qualityMonitor = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/QualityManagerV2/SafeMonitor`,params,header).then(res => res); };

//绿色施工=========================================================================
//环境
export const envMonitor = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/GreenWorkV2/EnvMonitor`,params,header).then(res => res); };
//用电
export const eleSave = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/GreenWorkV2/EleSave`,params,header).then(res => res); };
//用水
export const waterSave = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/GreenWorkV2/WaterSave`,params,header).then(res => res); };

//设备管理=========================================================================
//设备数据-塔吊数据统计
export const tower = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/DevManagerV2/Tower`,params,header).then(res => res); };
//设备数据-电梯
export const elevator = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/DevManagerV2/Elevator`,params,header).then(res => res); };
//设备数据安防
export const rail = (params,header) => { return axios.post(`http://www.biaima.com.cn/api/BigV2/DevManagerV2/Rail`,params,header).then(res => res); };

//地磅
export const loaderStore = (params,header) => { return axios.get(`http://www.biaima.com.cn/api/DevManager/SearchLoaderStore`,{ params: params }); }



//进度计划
export const createProgress = (params,header) => { return axios.post(`${business}/progress/create`,params,header).then(res => res.data); };
export const updateProgress = (params,header) => { return axios.post(`${business}/progress/update`,params,header).then(res => res.data); };
export const searchProgress = (params,header) => { return axios.post(`${business}/progress/search`,params,header).then(res => res.data); };
export const delProgress = (params,header) => { return axios.post(`${business}/progress/del`,params,header).then(res => res.data); };
export const progressDetail = (params,header) => { return axios.post(`${business}/progress/detail`,params,header).then(res => res.data); };

//添加任务
export const createTask =  (params,header) => { return axios.post(`${business}/progress/createtask`,params,header).then(res => res.data); };
//修改任务
export const updateTask =  (params,header) => { return axios.post(`${business}/progress/updatetask`,params,header).then(res => res.data); };
//删除任务
export const delTask =  (params,header) => { return axios.post(`${business}/progress/deltask`,params,header).then(res => res.data); };
//任务详情
export const taskDetail =  (params,header) => { return axios.post(`${business}/progress/taskdetail`,params,header).then(res => res.data); };
//任务构件
export const taskActor =  (params,header) => { return axios.post(`${business}/progress/taskactor`,params,header).then(res => res.data); };
//任务构件分组
export const taskActorGroup =  (params,header) => { return axios.post(`${business}/progress/taskactorgroup`,params,header).then(res => res.data); };


//添加连接
export const createLink =  (params,header) => { return axios.post(`${business}/progress/createline`,params,header).then(res => res.data); };
//修改连接
export const updateLink =  (params,header) => { return axios.post(`${business}/progress/updateline`,params,header).then(res => res.data); };
//删除连接
export const delLink =  (params,header) => { return axios.post(`${business}/progress/delline`,params,header).then(res => res.data); };

//查询任务
export const searchTask =  (params,header) => { return axios.post(`${business}/progress/searchtask`,params,header).then(res => res.data); };
//任务最小时间
export const taskMinMaxTime =  (params,header) => { return axios.post(`${business}/progress/taskminmaxtime`,params,header).then(res => res.data); };
//是否含有子集
export const hasChild =  (params,header) => { return axios.post(`${business}/progress/haschild`,params,header).then(res => res.data); };

export const getTasks = (params,header) => { return axios.get(`${business}/progress/searchtask`,{ params: params }); }





















// WEBPACK FOOTER //
// ./src/api/api.js